import React from 'react';
import Presenter from './MyInfoPresenter'
import { useQuery } from '@apollo/react-hooks';
import { IS_ME } from '../../Queries/isme';
import gql from 'graphql-tag'
import Cookies from "js-cookie";
export default()=>{
    /**
     * 로그인하러가기
     */
      const QUERY = gql`
        {
          auth {
            isLoggedIn @client
          }
        }
      `;
      const { data: { auth: { isLoggedIn } } } = useQuery(QUERY)
      const onClick =() =>{
        Cookies.remove("sessionId")
        window.location.assign("/")
      }
      if(isLoggedIn){
        const {data, loading} = useQuery(IS_ME)
        return <Presenter data={data} loading={loading} onClick ={onClick} />;
      }else{
        return(
          "로그인해주세요"
        )
      }
    }
